/**
 * Check is hexadecimal
 * @param {string} text
 *
 * @returns {boolean}
 */
export function isHex(text) {
  return /^[0-9a-fA-F]{24}$/.test(text)
}

/**
 * Check image type file
 * @param {string} type
 *
 * @returns {boolean}
 */
export function isImage(type) {
  if (typeof type !== 'string') return false

  return /^image/.test(type.toLowerCase())
}